export default {
    driver_performance_events_driver_id: "Id Conductor",
    driver_performance_events_driver_name: "Conductor",
    driver_performance_events_driver_supervisor: "Supervisor",
    driver_performance_events_driver_tags: "Etiquetas",
    driver_performance_events_driver_no_driver_info: "No hay información disponible del conductor.",
    driver_performance_events_change_driver: "Cambiar Conductor",
}